<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="isTrialOver"
        class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
      >
        <div class="relative mx-0 py-30 px-30 bg-primary max-w-380 w-full rounded-4">
          <div class="h-full overflow-y-auto">
            <div class="text-app-color text-center">
              <img :src="require(`@/assets/images/teams.svg`)" class="mx-auto max-w-100 w-full" alt="teams">

              <p class="text-20 md:text-22 font-black mt-20">Your 15-days free trial <br> period is over.</p>

              <p class="text-14 mt-20 mb-25">
                If you want to keep using <span class="italic">hello ivy</span> for your business please upgrade to our Teams plan
              </p>
            </div>
            <div class="flex justify-center items-center">
              <!-- button -->
              <ButtonModule
                text="Upgrade now"
                class="px-25 py-10 text-14 rounded-6 justify-center text-white bg-link-color hover:bg-transparent hover:text-link-color border-2 border-link-color"
                @click="upgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, computed } from 'vue'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'TrialIsOff',

  components: { ButtonModule },

  setup () {
    const { commit, getters } = useStore()

    const isTrialOver = computed(() => getters.isTrialOver)
    const isMobile = computed(() => getters.isMobile)

    function upgrade () {
      if (isMobile.value) {
        commit('toggleAside', false)
      }
      commit('changeActiveState', 'Plans')
      commit('toggleSettingsModal', true)
    }

    return {
      // computed
      isTrialOver,
      // function
      upgrade
    }
  }

})
</script>
